import { ICreateOrderInitialState } from "./types";

const initialState: ICreateOrderInitialState = {
  readOnlyTakeOff: false,
};

export default initialState;